import requests from "./httpService";

const formatDate = (date) => {
  if (!date) return null;

  const d = new Date(date);
  if (isNaN(d.getTime())) return null;

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

const OnewayPickupPeriodicHikeDayServices = {
  getAllONewayPickupPeriodicHikeDay: async () => {
    return requests.get(`/onewaypickhikeday/`);
  },

  addOnewayPickupPeriodicHikeDay: async (body) => {
    const formattedBody = {
      ...body,
      start_date: formatDate(body.start_date),
      end_date: formatDate(body.end_date),
    };

    return requests.post(`/onewaypickhikeday/add`, formattedBody);
  },

  getOnewayPickupPeriodicHikeDayById: async (id) => {
    return requests.get(`/onewaypickhikeday/${id}`);
  },

  updateOnewayPickupPeriodicHikeDay: async (id, body) => {
    const formattedBody = {
      ...body,
      start_date: formatDate(body.start_date),
      end_date: formatDate(body.end_date),
    };

    return requests.put(`/onewaypickhikeday/update/${id}`, formattedBody);
  },

  deleteOnewayPickupPeriodicHikeDay: async (id) => {
    return requests.delete(`/onewaypickhikeday/delete/${id}`);
  },
};

export default OnewayPickupPeriodicHikeDayServices;
